@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <button
    pButton
    pRipple
    type="button"
    icon="fa fa-angle-down"
    [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
    iconPos="right"
    class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
    (click)="action.toggle($event)"
  ></button>
  <p-popover #action styleClass="overflow-hidden text-sm w-8rem -ml-5">
    <ng-template #content>
      <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
        @if ($.adata.includes('edit')) {
          <li
            (click)="executeAction('edit', $.row, action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
          >
            <i class="fa fa-pencil text-xs mr-2"></i
            >{{ 'ADMIN.COMMON.EDIT' | translate }}
          </li>
        }
        @if ($.adata.includes('status')) {
          <li
            (click)="executeAction('status', $.row, action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
          >
            <i
              [ngClass]="isActive($.row) ? 'fa-eye' : 'fa-eye-slash'"
              class="pi text-xs mr-2"
            ></i
            >{{ 'Shared.TASK.TASK-CREATE.MARK' | translate }}
            {{ isActive($.row) ? 'In-active' : 'Active' }}
          </li>
        }
        @if ($.adata.includes('delete')) {
          <li
            (click)="executeAction('delete', $.row, action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
          >
            <i class="fa fa-trash-alt text-xs mr-2"></i
            >{{ 'ADMIN.COMMON.DELETE' | translate }}
          </li>
        }
        @if ($.adata.includes('copyFormLink') && $.row?.member_form_link) {
          <li
            (click)="executeAction('copyFormLink', $.row, action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
            aria-label="copy-form-link-action"
          >
            <i class="fa fa-link text-xs mr-2"></i
            >{{ 'CLIENT_PROFILE.FORMS.COPY_FORM_LINK' | translate }}
          </li>
        }
      </ul>
    </ng-template>
  </p-popover>
}
